import '../../styles/web-components/tooltip-popup.scss';
import { getElementOrParentByClassName } from '../helpers/utils';
import { showDialog } from '../services/dialog.service';
class TooltipPopup extends HTMLElement {
    constructor() {
        super();
        this.addEventListener("click", (e) => {
            const target = e.target;
            if (getElementOrParentByClassName(target, 'tooltip__button')) {
                if (this.dialogWrapper && this.dialogWrapper.isOpen()) {
                    this.closePopover();
                }
                else {
                    this.showPopover();
                }
            }
        });
    }
    connectedCallback() {
        this.render();
    }
    showPopover() {
        const content = ['popup-header', 'popup-body'].map(attr => {
            const text = this.getAttribute(attr);
            if (text) {
                const type = attr.split("-")[1];
                const el = document.createElement('p');
                el.classList.add(`tooltip__popup-${type}`);
                el.textContent = text;
                return el;
            }
        }).filter(x => !!x);
        this.dialogWrapper = showDialog(content, { classes: ['tooltip__dialog'], appendTo: this });
    }
    closePopover() {
        if (this.dialogWrapper) {
            this.dialogWrapper.close();
        }
    }
    render() {
        const backgroundColor = this.getAttribute('tooltip-color');
        this.innerHTML = `
      <button type="button" class="tooltip__button" style="${backgroundColor ? `background-color: ${backgroundColor}` : ''}">
        <span class="tooltip__icon" aria-hidden="true">i</span>
        <span class="ADA__visually-hidden">More information</span>
      </button>
    `;
    }
}
if (!window.customElements.get("tooltip-popup")) {
    customElements.define("tooltip-popup", TooltipPopup);
}
